import moment from 'moment';
import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import { Declaration } from 'store/declarations/declaration';
import AntTooltip from 'components/ui/base/tooltip/Tooltip';
import DeclarationDate from '../DeclarationDate';

type Props = {
    dataTestId: string;
    declaration?: Declaration;
};

const Edited = ({ dataTestId, declaration }: Props) => {
    if (!declaration?.updatedAt) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    const date = moment(declaration.updatedAt);
    const formattedTime = date.format('HH:mm A');
    const formattedDate = date.format('DD/MM/YY');

    return (
        <AntTooltip
            placement="bottomLeft"
            color="white"
            overlay={<DeclarationDate createdDate declaration={declaration} />}
        >
            <span data-testid={dataTestId}>
                <div>{formattedDate}</div>
                <div>{formattedTime}</div>
            </span>
        </AntTooltip>
    );
};

export default Edited;
